import React, { useEffect, useState } from "react";
import { Card, ListGroup, Spinner, Badge, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import "./TrancheList.css";
import TrancheDeleteModal from "./TrancheDeleteModal";
import { showNotification } from "../../service/showNotification";
import { deleteTrancheBot } from "../../service/api";
import Skeleton from "react-loading-skeleton";
const TrancheList = ({ tranches, isListLoading, fetchAllTranches }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const toggleExpand = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const calculateTimeLeft = (expireOn) => {
    const now = new Date();
    const expires = new Date(expireOn);
    const diffMs = expires.getTime() - now.getTime();

    if (diffMs <= 0) return "Expired";

    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const remainingMinutes = diffMinutes % 60;

    if (diffHours > 0) {
      return `${diffHours}h left`;
    } else if (remainingMinutes > 0) {
      return `${remainingMinutes}m left`;
    } else {
      return "Less than a minute left";
    }
  };

  const handleDeleteModal = async () => {
    if (!deleteId) return;

    try {
      console.log("Id to delete is:", deleteId);
      await deleteTrancheBot(deleteId);
      setShowDeleteModal(false);
      showNotification("success", "Tranche deleted successfully");
      await fetchAllTranches();
    } catch (error) {
      console.error("Error deleting tranche:", error);
      showNotification("error", "Failed to delete tranche. Please try again.");
    }
  };

  return (
    <>
      <Card className="tranche-card p-3">
        <Card.Title className="tranche-card-header">All Tranches</Card.Title>
        {isListLoading ? (
          <div>
            <Skeleton count={4} height={65} width={"100%"} />
          </div>
        ) : tranches.length === 0 ? (
          <div className="no-tranches-message">No tranches found.</div>
        ) : (
          <ListGroup className="pt-1 list-group">
            {tranches.map((tranche) => (
              <>
                <ListGroup.Item key={tranche._id} className="tranche-item">
                  <div className="tranche-item-header">
                    <div className="tranche-item-main">
                      <div className="ticket-opportunity">
                        <span className="ticket-no">#{tranche.ticketNo}</span>
                      </div>
                      <div className="tranche-header-actions">
                        <Badge bg="warning" className="time-badge">
                          {calculateTimeLeft(tranche.expireOn)}
                        </Badge>
                        <div
                          onClick={() => {
                            setShowDeleteModal(true);
                            setDeleteId(tranche._id);
                          }}
                        >
                          <FaTrash className="delete-btn" size={14} />
                        </div>
                      </div>
                    </div>
                    <div className="opportunity-id">{tranche.contactName}</div>

                    <div className="meta">
                      <div className="meta-left">
                        <Badge
                          bg={
                            tranche.currentStatus === "Invalid" ||
                            tranche.currentStatus === "Failed"
                              ? "danger"
                              : tranche.currentStatus === "Completed"
                              ? "success"
                              : "info"
                          }
                          className="stage-badge"
                        >
                          {tranche.currentStatus}
                        </Badge>
                      </div>
                      <div className="meta-right">
                        <span
                          className="expand-icon"
                          onClick={() => toggleExpand(tranche._id)}
                        >
                          {expandedItems[tranche._id] ? (
                            <FaChevronUp />
                          ) : (
                            <FaChevronDown />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  {expandedItems[tranche._id] && (
                    <div className="tranche-details">
                      <div className="detail-item">
                        <span className="detail-label">Opportunity Id:</span>
                        <span className="detail-value">
                          {tranche.opportunityId}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">ITC Percent:</span>
                        <span className="detail-value">
                          {tranche.itcPercent}%
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">States:</span>
                        <span className="detail-value">
                          {tranche.states.join(", ")}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">
                          {tranche.contactGroup == "AmpVantage Energy"
                            ? "30% Markup %"
                            : "Affiliate Markup"}{" "}
                        </span>
                        <span className="detail-value">
                          {tranche.internalMarkupPercent}%
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">
                          {tranche.contactGroup == "AmpVantage Energy"
                            ? "40% Markup %"
                            : "Affiliate Markup"}
                          {""}
                        </span>
                        <span className="detail-value">
                          {tranche.affiliateMarkupPercent}%
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Total Remainder:</span>
                        <span className="detail-value">
                          ${tranche.totalRemainder}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Contact Group:</span>
                        <span className="detail-value">
                          {tranche.contactGroup}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Asset Provider:</span>
                        <span className="detail-value">
                          {tranche.assetDealSource}
                        </span>
                      </div>
                      {tranche.assets.length !== 0 && (
                        <>
                          <div className="detail-item">
                            <span className="detail-label">
                              Total Purchase Amount:
                            </span>
                            <span className="detail-totalPurchase">
                              <Badge
                                bg={
                                  tranche.totalPurchaseAmount >=
                                  tranche.totalRemainder * 0.95
                                    ? "success"
                                    : "danger"
                                }
                              >
                                ${tranche.totalPurchaseAmount}
                              </Badge>
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">
                              Total Itc Percentage:
                            </span>
                            <span className="detail-totalPurchase">
                              <Badge
                                bg={
                                  tranche.totalPurchaseAmount >=
                                  tranche.totalRemainder * 0.95
                                    ? "success"
                                    : "danger"
                                }
                              >
                                {tranche.totalItcPercent.toFixed(2)}%
                              </Badge>
                            </span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">Assets :</span>
                            <div className="assets-list">
                              {tranche.assets?.map((asset, key) => (
                                <div className="asset-item" key={key}>
                                  <span className="asset-name">{asset}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </ListGroup.Item>
                <hr />
              </>
            ))}
          </ListGroup>
        )}
      </Card>
      {showDeleteModal && (
        <TrancheDeleteModal
          setShowDeleteModal={setShowDeleteModal}
          showDeleteModal={showDeleteModal}
          handleDeleteModal={handleDeleteModal}
        />
      )}
    </>
  );
};

export default TrancheList;
